import React, { Component } from 'react';
import PropTypes from 'prop-types';

class StatsMenu extends Component {
  constructor(props) {
    super(props);

    this.menu = [
      {
        key: 'visits',
        label: 'Visitas',
      },
      {
        key: 'countries',
        label: 'Paises',
      },
      {
        key: 'users',
        label: 'Usuarios',
      },
      {
        key: 'referrers',
        label: 'Origenes',
      },
    ];
  }


  render() {
    const { active } = this.props;
    return (
      <div className="analytics__sidebar-internal">
        {this.menu.map(i => (
          <button
            key={i.key}
            className={`analytics__menu-item ${active === i.key ? 'active' : ''}`}
            onClick={() => this.props.onChange(i.key)}
          >
            {i.label}
          </button>
        ))}
      </div>
    );
  }
}

StatsMenu.propTypes = {
  active: PropTypes.string,
  onChange: PropTypes.func,
};

StatsMenu.defaultProps = {
  active: undefined,
  onChange: () => {},
};

export default StatsMenu;



// WEBPACK FOOTER //
// ./src/components/StatsMenu/index.js